import React, { useState } from 'react';

const LogoSlider = () => {
  const [loadedImages, setLoadedImages] = useState(new Set());
  
  // Static list of logos
  const logos = Array.from({ length: 18 }, (_, i) => ({
    src: process.env.PUBLIC_URL + `/images/brands/${i + 1}.png`,
    alt: `Brand Logo ${i + 1}`
  }));

  const handleImageLoad = (imageId) => {
    setLoadedImages(prev => new Set([...prev, imageId]));
  };

  const renderLogos = (setNumber) => {
    return logos.map((logo, index) => {
      const imageId = `set${setNumber}-${index}`;
      return (
        <div 
          key={imageId} 
          className={`flex-none mx-4 w-[180px] logo-slide ${loadedImages.has(imageId) ? 'loaded' : ''}`}
        >
          <div className="h-[120px] flex items-center justify-center">
            <img
              src={logo.src}
              alt={logo.alt}
              className="max-w-full max-h-full object-contain"
              onLoad={() => handleImageLoad(imageId)}
              onError={(e) => {
                console.error(`Failed to load image: ${logo.src}`);
                e.target.style.display = 'none';
              }}
            />
          </div>
        </div>
      );
    });
  };

  return (
    <section className="bg-[#F5E7C6] py-16">
      <div className="mb-8 text-center">
        <h3 className="text-2xl font-bold text-black/80">Trusted by Leading Brands</h3>
      </div>

      <div className="slider-container">
        <div className="logo-track overflow-hidden">
          <div className="animate-logo-mobile-scroll md:animate-logo-scroll flex">
            {renderLogos(1)}
            {renderLogos(2)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoSlider;
